import React from 'react';

export const Title = (props) => {

    if(typeof props['header'] !== 'undefined') return <h1 className='header'>{props['header']}</h1>
}